import { defineMessages } from 'react-intl';

export default defineMessages({
    licenseDetails: {
        id: 'agent.registration.views.LicenseNumber',
        defaultMessage: 'TDI License Number',
    },
    UWCompany: {
        id: 'agent.registration.views.UWCompany',
        defaultMessage: 'UW Company',
    },
    pleaseChoose: {
        id: 'agent.registration.views.Please Choose',
        defaultMessage: 'Please Choose',
    },
    SSN: {
        id: 'agent.registration.views.SSN',
        defaultMessage: 'Social Security Number (SSN)',
    },
    EIN: {
        id: 'agent.registration.views.EIN',
        defaultMessage: 'Employer Identification Number (EIN)',
    },
    lastName: {
        id: 'agent.registration.views.AgentContactName',
        defaultMessage: 'Agency Contact Last Name',
    },
    agencyNotFound: {
        id: 'agent.registration.views.AgencySearch.Agent Not in TDI database',
        defaultMessage:
            'The TDI license number you entered is not in our database. Please verify the license number and try again. If you still receive this error, please contact the Texas Department of Insurance (https://tdi.texas.gov).',
    },
    error: {
        id: 'agent.registration.views.AgencySearch.Error',
        defaultMessage: 'Error Processing Request',
    },
    TFPA: {
        id: 'agent.registration.views.tfpa title',
        defaultMessage: 'Texas FAIR Plan Association',
    },
    invalidLicense: {
        id: 'agent.registration.messages.InvalidLicense',
        defaultMessage:'The TDI license number is not currently listed with TDI.',
    },
    NotGLPCLicense: {
        id: 'agent.registration.messages.NotGLPCLicense',
        defaultMessage:'The TDI license number is not a Not General Lines Property and Casual license, please update and try again',
    },
    TWIALicenseInUse: {
        id: 'agent.registration.messages.TWIALicenseInUse',
        defaultMessage:'The TDI license number you entered is already registered with TWIA. Please contact Agent Services (agentservices@twia.org).',
    },
    LicenseInUse: {
        id: 'agent.registration.messages.LicenseInUse',
        defaultMessage:'The TDI license number you entered is already registered with TFPA. Please contact Agent Services (AgentServices@twia.org)',
    },
    EmailInUse: {
        id: 'agent.registration.messages.EmailInUse',
        defaultMessage:'Email address you entered already exists in our system. Enter another email address to register with TFPA.',
    },
    RegistrationNotFoundTitle: {
        id: 'agent.registration.messages.RegistrationNotFoundTitle',
        defaultMessage:'Invalid Activation',
    },
    RegistrationNotFoundBody: {
        id: 'agent.registration.messages.RegistrationNotFoundBody',
        defaultMessage:'The information you entered does not match our records. Please try again.',
    },
    RegistrationComplete: {
        id: 'agent.registration.messages.RegistrationComplete',
        defaultMessage:'Registration process completed.',
    },
    InvalidLicenseUpdate: {
        id: 'agent.registration.messages.InvalidLicenseUpdate',
        defaultMessage:'Cannot change agency license numbers',
    },
    TWIAExpiredLicense: {
        id: 'agent.registration.messages.TWIAExpiredLicense',
        defaultMessage:'The TDI license number you entered is expired. To register with TWIA, you must have an active TDI license.',
    },
    ExpiredLicense: {
        id: 'agent.registration.messages.ExpiredLicense',
        defaultMessage:'The TDI license number you entered is expired. To register with TFPA, you must have an active TDI license.',
    },
    UnableToValidate: {
        id: 'agent.registration.messages.UnableToValidate',
        defaultMessage:'Unable to validate the TDI License Number provided',
    },
})
